import React from "react";

export const FullScreenBackdrop = ({ children }) => (
  <div
    id="FullScreenBackdrop"
    style={{
      // background:
      //   "radial-gradient(circle at center top, #5E2EA1 -0%, #21103B 100%)",
      display: "flex",
      width: "100vw",
      height: "100vh",
      color: "white",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {children}
  </div>
);
